import React from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"

import asyncActions from "../../../state/async-actions"

import { FeatureGroup, Map, LayersControl, ScaleControl, TileLayer, ZoomControl, WMSTileLayer } from "react-leaflet"

import TopoJSON from "../utils/TopoJSON"

import L from "leaflet"

import "leaflet/dist/leaflet.css"
import "./HKVMap.css"

// Verwijderen van standaard leaflet markers
delete L.Icon.Default.prototype._getIconUrl

// Default markers toekennen aan leaflet
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("../assets/marker.png"),
  iconUrl: require("../assets/marker.png"),
  shadowUrl: require("../assets/marker-shadow.png")
})

const { BaseLayer, Overlay } = LayersControl

class HKVMap extends React.Component {
  constructor(props) {
    super(props)

    // Aanmaken van mapReferences
    this.mapRef = React.createRef()
    this.featureGroupRef = React.createRef()
  }

  componentDidMount = () => {
    const { config, mapDidMount } = this.props

    // Ophalen van features opbasis van meegegeven URL
    // this.fetchFeatures(config)

    // MapReference meegeven aan je App.js zodat je altijd bij de layers kan
    this.mapRef.current.key = `mapRef${config.key}`

    mapDidMount(this.mapRef.current)
  }

  // Ophalen van features opbasis van meegegeven URL
  fetchFeatures = (config) => {
    config.layers.forEach((layer, index) => {
      if (layer.url.length === 0) return null
      this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
        .then(() => {
          fetch(layer.url)
            .then(response => response.json())
            .then(json => {
              // Opgehaalde features plaatsen in de betreffende layer zijn lege features array
              config.layers[index].features = json.features

              this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
            })
        })
    })
  }

  // Functie die wordt aangeroepen voor het toevoegen van de feature aan de <TopoJSON />
  onEachFeature = (event, feature) => {
    const { determineFeatureStyle } = this.props

    if (feature instanceof L.Marker) {
      // Do niks
    } else if ((feature instanceof L.Polyline) || (feature instanceof L.Polygon)) {
      // Wanneer je een determineFeatureStyle functie meegeeft aan het HKVMap component
      if (determineFeatureStyle) {
        // Feature stylen in App.js
        feature.setStyle(determineFeatureStyle(feature, "polyline"))
      }
    } else {
      // Do niks
    }
  }

  // Functie die wordt aangeroepen voor het toevoegen van pointers aan de <TopoJSON />
  pointToLayer = (feature, latlng, layer) => {
    const { determineFeatureOptions } = this.props

    // Switch op bases van de in de config meegegeven layerType, keuze uit circle en marker
    switch (layer.pointerType) {
      case "circle":
        // Wanneer je een determineFeatureOptions functie meegeeft aan het HKVMap component
        if (determineFeatureOptions) {
          // CircleMarker options in App.js bepalen
          return L.circleMarker(latlng, determineFeatureOptions(feature, "circle"))
        } else {
          // Standaard circleMarker creeëren
          return L.circleMarker(latlng, {})
        }

      case "marker":
      default:
        // Wanneer je een determineFeatureOptions functie meegeeft aan het HKVMap component
        if (determineFeatureOptions) {
          // Marker options in App.js bepalen
          return L.marker(latlng, determineFeatureOptions(feature, "marker"))
        } else {
          // Standaard marker creeëren
          return L.marker(latlng, {})
        }
    }
  }

  onFeatureGroupUpdate = (event, layer, i) => {
    const map = this.mapRef.current.leafletElement // get native Map instance
    const group = event.target

    // Op basis van config bepalen of we zoomen of niet
    if (layer && layer.zoomTo) {
      if (layer.features.length === i) {
        if (group.getBounds().isValid()) {
          this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
            .then(() => {
              map.fitBounds(group.getBounds())
              this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
            })
        }
      }
    }
  }

  // Na aanmaken van featureGroup
  onFeatureGroupAdd = (event, layer) => {
    const map = this.mapRef.current.leafletElement // get native Map instance
    const group = event.target // get native featureGroup instance

    group.name = layer.name
    group.key = layer.key
    
    if (this.props.featureGroupDidAdd) {
      this.props.featureGroupDidAdd(group)
    }

    // Op basis van config bepalen of we zoomen of niet
    if (layer && layer.zoomTo) {
      const bounds = group.getBounds()
      if (bounds.isValid()) {
        // Alleen zoomen wanneer bounds valide zijn
        this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
          .then(() => {
            map.fitBounds(group.getBounds())
            this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
          })
      }
    }
  }

  // Renderen van verschillende controls op basis van layer zijn config
  renderControl = (control, index) => {
    const { config, t } = this.props

    switch (control.name) {
      case "LayersControl":
        return (
          <LayersControl key={index} position={control.position}>
            {config.baseLayers.map((baseLayer, index) => (
              <BaseLayer key={index} checked={baseLayer.checked} name={t(baseLayer.name)}>
                <TileLayer
                  attribution={baseLayer.attribution}
                  url={baseLayer.url}
                />
              </BaseLayer>
            ))}
            {config.layers.map((layer, index) => {
              if (layer.features.length === 0) {
                if (layer.type === "wms") {
                  let layers = layer.layer

                  if (layer.workspace) {
                    if (layer.workspace.length > 0) {
                      layers = `${layer.workspace}:${layer.layer}`
                    }
                  }
                  return (
                    <Overlay key={index} checked={layer.checked} name={layer.name}>
                      <WMSTileLayer
                        onAdd={(event) => this.onFeatureGroupAdd(event, layer)}
                        url={layer.url}
                        layers={layers}
                        styles={layer.styles}
                        format="image/png"
                        transparent
                      />
                    </Overlay>
                  )
                } else {
                  return null
                }
              }
              let i = 1
              return (
                <Overlay key={index} checked={layer.checked} name={layer.name}>
                  <FeatureGroup ref={this.featureGroupRef} onAdd={(event) => this.onFeatureGroupAdd(event, layer)}>
                    <TopoJSON
                      onAdd={(event) => this.onFeatureGroupUpdate(event, layer)}
                      onlayeradd={(event) => this.onFeatureGroupUpdate(event, layer, i++)}
                      key={layer.features.length}
                      data={layer.features}
                      onEachFeature={this.onEachFeature}
                      pointToLayer={(feature, latlng) => this.pointToLayer(feature, latlng, layer)}
                      onMouseOver={this.handleFeatureMouseOver}
                      onMouseOut={this.handleFeatureMouseOut}
                      onClick={this.handleFeatureClick}
                    />
                  </FeatureGroup>
                </Overlay>
              )
            })}
          </LayersControl>
        )

      case "ZoomControl":
        return <ZoomControl key={index} position={control.position} />

      case "ScaleControl":
        return <ScaleControl key={index} position={control.position} imperial={control.metric ? false : true} metric={control.metric ? true : false} />

      default:
        return null
    }
  }

  // Click on map functie
  handleMapClick = (event) => {
    const { handleMapClick } = this.props

    // Wanneer je een handleMapClick functie meegeeft aan het HKVMap component
    if (handleMapClick) {
      this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
        .then(() => {
          handleMapClick(this.mapRef.current, event)
        })
    }
  }

  // Click on feature functie
  handleFeatureClick = (event) => {
    const { handleFeatureClick } = this.props

    // Click op map functie preventen (https://stackoverflow.com/questions/50736530/react-leaflet-stop-propagation-when-click-on-a-drawn-polygon)
    event.originalEvent.view.L.DomEvent.stopPropagation(event)

    if (handleFeatureClick) {
      this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
        .then(() => {
          handleFeatureClick(this.mapRef.current, event)
        })
    }
  }

  // Mouse over Feature functie
  onMouseOver = (event) => {
    const { handleFeatureMouseOver } = this.props

    // Wanneer je een handleFeatureMouseOver functie meegeeft aan het HKVMap component
    if (handleFeatureMouseOver) {
      this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
        .then(() => {
          handleFeatureMouseOver(this.mapRef.current, event)
        })
    }
  }

  // Mouse out Feature functie
  onMouseOut = (event) => {
    const { handleFeatureMouseOut } = this.props

    // Wanneer je een handleFeatureMouseOut functie meegeeft aan het HKVMap component
    if (handleFeatureMouseOut) {
      this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
        .then(() => {
          handleFeatureMouseOut(this.mapRef.current, event)
        })
    }
  }

  render() {
    const { config } = this.props

    if (!config) return null

    const position = [config.lat, config.lng]

    return (
      <Map
        center={position}
        zoom={config.zoom}
        style={{ height: "100%" }}
        ref={this.mapRef}
        onClick={this.handleMapClick}
        zoomControl={false}
      >
        {config.controls.map((control, index) => (
          this.renderControl(control, index)
        ))}
      </Map>
    )
  }
}

HKVMap = withTranslation("translation")(HKVMap)
export default connect(state => state)(HKVMap)
